Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var debugBuild = require('../debug-build.js');
var logger = require('../utils-hoist/logger.js');
var spanUtils = require('../utils/spanUtils.js');

/**
 * Print a log message for a started span.
 */
function logSpanStart(span) {
  if (!debugBuild.DEBUG_BUILD) return;
  var _spanUtils$spanToJSON = spanUtils.spanToJSON(span),
    _spanUtils$spanToJSON2 = _spanUtils$spanToJSON.description,
    description = _spanUtils$spanToJSON2 === void 0 ? '< unknown name >' : _spanUtils$spanToJSON2,
    _spanUtils$spanToJSON3 = _spanUtils$spanToJSON.op,
    op = _spanUtils$spanToJSON3 === void 0 ? '< unknown op >' : _spanUtils$spanToJSON3,
    parentSpanId = _spanUtils$spanToJSON.parent_span_id;
  var _span$spanContext = span.spanContext(),
    spanId = _span$spanContext.spanId;
  var sampled = spanUtils.spanIsSampled(span);
  var rootSpan = spanUtils.getRootSpan(span);
  var isRootSpan = rootSpan === span;
  var header = "[Tracing] Starting ".concat(sampled ? 'sampled' : 'unsampled', " ").concat(isRootSpan ? 'root ' : '', "span");
  var infoParts = ["op: ".concat(op), "name: ".concat(description), "ID: ".concat(spanId)];
  if (parentSpanId) {
    infoParts.push("parent ID: ".concat(parentSpanId));
  }
  if (!isRootSpan) {
    var _spanUtils$spanToJSON4 = spanUtils.spanToJSON(rootSpan),
      _op = _spanUtils$spanToJSON4.op,
      _description = _spanUtils$spanToJSON4.description;
    infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));
    if (_op) {
      infoParts.push("root op: ".concat(_op));
    }
    if (_description) {
      infoParts.push("root description: ".concat(_description));
    }
  }
  logger.logger.log("".concat(header, "\n  ").concat(infoParts.join('\n  ')));
}

/**
 * Print a log message for an ended span.
 */
function logSpanEnd(span) {
  if (!debugBuild.DEBUG_BUILD) return;
  var _spanUtils$spanToJSON5 = spanUtils.spanToJSON(span),
    _spanUtils$spanToJSON6 = _spanUtils$spanToJSON5.description,
    description = _spanUtils$spanToJSON6 === void 0 ? '< unknown name >' : _spanUtils$spanToJSON6,
    _spanUtils$spanToJSON7 = _spanUtils$spanToJSON5.op,
    op = _spanUtils$spanToJSON7 === void 0 ? '< unknown op >' : _spanUtils$spanToJSON7;
  var _span$spanContext2 = span.spanContext(),
    spanId = _span$spanContext2.spanId;
  var rootSpan = spanUtils.getRootSpan(span);
  var isRootSpan = rootSpan === span;
  var msg = "[Tracing] Finishing \"".concat(op, "\" ").concat(isRootSpan ? 'root ' : '', "span \"").concat(description, "\" with ID ").concat(spanId);
  logger.logger.log(msg);
}
exports.logSpanEnd = logSpanEnd;
exports.logSpanStart = logSpanStart;